'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

//EwSiteApp.requires.push('flow');
//EwSiteApp.requires.push('ui.bootstrap');

//function modalRejectHandler(result){
//	console.log(result);
//}

//EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
//	flowFactoryProvider.defaults = {
//		target: '',
//		permanentErrors: [202, 404, 500, 501],
//		maxChunkRetries: 1,
//		chunkRetryInterval: 5000,
//		simultaneousUploads: 1,
//		singleFile: false,
//		chunkSize: 2 * 1024 * 1024,
//		forceChunkSize: true
//	};
//	// Add XSRF header to upload requests
//	if (typeof (secure_xsrf_name) != 'undefined') {
//		var xsrf_token = getJsCookieValue(secure_xsrf_name);
//		if (xsrf_token !== '') {
//			flowFactoryProvider.defaults.headers = {};
//			flowFactoryProvider.defaults.headers['X-' + secure_xsrf_name] = xsrf_token;
//		}
//	}
//	flowFactoryProvider.on('fileSuccess', function (file, response) {
//		try{
//			eval("var d = " + response);
//			if(typeof(d.success) !== 'undefined'){
//				file.response = d;
//			}
//		}
//		catch(err){
//			console.error('Network Error: bad response format - '+err.message);
//		}
//	});
////	flowFactoryProvider.on('catchAll', function (event) {
////	 console.log('catchAll', arguments);
////	 });
//
////	 flowFactoryProvider.on('fileAdded', function (event) {
////	 console.log(event);
////	 });
//	// Can be used with different implementations of Flow.js
//	// flowFactoryProvider.factory = fustyFlowFactory;
//}]);

EwSiteApp.controller('MultiUploadThirdpersons', ['$scope', '$filter', '$log', function ($scope, $filter, $log) {
		$scope.uploaded_files = [];
		$scope.files = [];
		$scope.files.errors = [];
		$scope.files.hasError = false;
		$scope.max_file_size = 0;
		$scope.max_files = 0;
		// flow.js fires fileAdded for every file of a selection before any of them
		// lands in $flow.files, so accepted files of the current selection are counted here
		var accepted_in_batch = 0;
		var limit_error_shown = false;
		var flow_ref = null;
		$scope.closeAlert = function (index) {
			$scope.files.errors.splice(index, 1);
//		$scope.errors.splice(index, 1);
		};

		$scope.transmitToParent = function () {
			$scope.$parent.uploads_count += 1;
			$scope.$parent.total_upl += 1;
		};

		// uploadStart iššaukiamas dar prieš pradedant siųsti pirmą gabalą,
		// todėl čia isUploading() dar grąžintų false - vėliava keliama tiesiogiai
		$scope.onUploadStart = function (flowObj) {
			flow_ref = flowObj || flow_ref;
			$scope.$parent.files_uploading = true;
		};

		// perskaičiuojama iš paties flow objekto, kad vėliava neužstrigtų,
		// kai paskutinis siunčiamas failas pašalinamas ar nukrenta su klaida
		$scope.syncUploading = function (flowObj) {
			flow_ref = flowObj || flow_ref;
			$scope.$parent.files_uploading = flow_ref ? flow_ref.isUploading() : false;
		};

		$scope.onFilesAdded = function () {
			accepted_in_batch = 0;
			limit_error_shown = false;
		};

		$scope.onFileAdded = function ($file, extensions, flowObj) {
			var output = false;
			var max_files = parseInt($scope.max_files, 10) || 0;
			if (max_files > 0) {
				var current = (flowObj && flowObj.files ? flowObj.files.length : 0) + accepted_in_batch;
				if (current >= max_files) {
					if (!limit_error_shown) {
						limit_error_shown = true;
						$scope.files.hasError = true;
						$scope.files.errors.push(($scope.max_files_msg || '').replace('%d', max_files));
					}
					return output;
				}
			}
			if ($scope.max_file_size > 0 && $file.size > $scope.max_file_size) {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' - File too large');
				return output;
			}
			if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
				output = true;
			}
			if (!output) {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' ' + $scope.error_msg);
			} else {
				accepted_in_batch += 1;
			}
			return output;
		};

		function flowErrors($file) {
			if (typeof ($file.response) !== 'undefined') {
				if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
					return true;
				} else if (typeof ($file.response.message) !== 'undefined') {
					$scope.files.hasError = true;
					$scope.files.errors.push($file.name + ' - ' + $file.response.message);
					return false;
				}
			} else {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' - Server error');
				return false;
			}
			return null;
		}

		$scope.onFileSuccess = function ($file, $message, flowFile) {
			let flow_errors = flowErrors($file);
			if (true === flow_errors) {
				$scope.transmitToParent();
			} else if (false === flow_errors) {
				flowFile.cancel();
			}
		};

		$scope.onFileError = function ($file, $message, flowFile) {
			if (false === flowErrors($file)) {
				flowFile.cancel();
			}
		};

		$scope.removeufile = function (ufile) {
			$scope.uploaded_files = $filter('filter')($scope.uploaded_files, {id: '!' + ufile.id}, true);
			$scope.decreaseUplCount();
		};


		$scope.removeUploaded = function (file) {
			file.cancel();
			$scope.decreaseUplCount();
		};
		$scope.decreaseUplCount = function () {

			if ($scope.$parent.uploads_count > 0) {
				$scope.$parent.uploads_count -= 1;
			}

			if ($scope.$parent.total_upl > 0) {
				$scope.$parent.total_upl -= 1;
			}
		};
	}]);

EwSiteApp.controller('SingleFileThirdPersons', ['$scope', '$filter', '$log', '$http', function ($scope, $filter, $log, $http) {
		$scope.uploaded_file = 0;
		$scope.brez_file = 0;
		$scope.errors = [];
		$scope.hasError = false;
		$scope.max_file_size = 0;
		var flow_ref = null;
		$scope.closeAlert = function (index) {
			$scope.errors.splice(index, 1);
		};

		$scope.transmitToParent = function () {
			$scope.$parent.uploaded_brezinys = true;
			$scope.$parent.total_upl += 1;
		};

		$scope.onUploadStart = function (flowObj) {
			flow_ref = flowObj || flow_ref;
			$scope.$parent.brez_uploading = true;
		};

		$scope.syncUploading = function (flowObj) {
			flow_ref = flowObj || flow_ref;
			$scope.$parent.brez_uploading = flow_ref ? flow_ref.isUploading() : false;
		};

		$scope.onFileAdded = function ($file, extensions) {
			var output = false;
			if ($scope.max_file_size > 0 && $file.size > $scope.max_file_size) {
				$scope.hasError = true;
				$scope.errors.push($file.name + ' - File too large');
				return output;
			}
			if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
				output = true;
			}
			if (!output) {
				$scope.hasError = true;
				$scope.errors.push($file.name + ' ' + $scope.error_msg);
			}
			return output;
		};

		function flowErrors($file) {
			if (typeof ($file.response) !== 'undefined') {
				if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
					return true;
				} else if (typeof ($file.response.message) !== 'undefined') {
					$scope.hasError = true;
					$scope.errors.push($file.name + ' - ' + $file.response.message);
					return false;
				}
			} else {
				$scope.hasError = true;
				$scope.errors.push($file.name + ' - Server error');
				return false;
			}
			return null;
		}

		$scope.onFileSuccess = function ($file, $message, flowFile) {
			let flow_errors = flowErrors($file);
			if (true === flow_errors) {
				$scope.transmitToParent();
				$scope.$parent.checkFile($file.response.fileId);
			} else if (false === flow_errors) {
				flowFile.cancel();
			}
		};

		$scope.onFileError = function ($file, $message, flowFile) {
			if (false === flowErrors($file)) {
				flowFile.cancel();
			}
		};

		$scope.removeufile = function () {
			$scope.$parent.uploaded_brezinys = false;
			$scope.uploaded_files = 0;
		};


		$scope.removeUploaded = function (file) {
			$scope.$parent.uploaded_brezinys = false;
			file.cancel();
		};

	}]);

EwSiteApp.controller('ThirdpersonsprojectsFormCtrl', ['$scope', '$http', '$filter', '$uibModal', '$log', '$timeout', '$interval', '$sce', 'SessionService', function ($scope, $http, $filter, $uibModal, $log, $timeout, $interval, $sce, SessionService) {
		$scope.form_id = "";
		$scope.uploads_count = 0;
		$scope.brez_uploads_count = 0;
		$scope.total_upl = 0;
		$scope.sumbitted = false;
		$scope.uploaded_brezinys = false;
		//failų įkėlimo būsena - kol true, pateikimo mygtukas blokuojamas
		$scope.files_uploading = false;
		$scope.brez_uploading = false;
		$scope.nrCheckUrl = thirdpersonsData.nrCheckUrl;
		$scope.form;
		$scope.submitted = false;
		$scope.displayStatus = 0;
		$scope.navigation = thirdpersonsData.navigation;
		$scope.checkRegNrUrl = thirdpersonsData.checkRegNrUrl;
		$scope.checkFileUrl = thirdpersonsData.checkFileUrl;
		$scope.projectNrCheckUrl = thirdpersonsData.projectNrCheckUrl;
		$scope.situation_title = [];
		$scope.checking_nr = false;
		$scope.check_data = {};
		$scope.brez_file_error = '';
		$scope.brez_file_valid = false;
		$scope.project_nr_valid = false;
		$scope.project_nr_found = false;

		$scope.$watch("phone", function (newVal) {
			if (newVal) {
				$scope.fullPhone = '+370' + newVal;
			} else {
				$scope.fullPhone = '';
			}
		});

		$scope.checkFile = function (file_id) {
			$scope.brez_file_error = '';
			$scope.brez_file_valid = false;
			if ($scope.checkFileUrl !== '' && file_id > 0) {
				$http({
					method: 'POST',
					url: $scope.checkFileUrl,
					data: {
						file_id: file_id
					},
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {
					$scope.regNrValid = response.data.success;
					if (response.data.success) {
						$scope.brez_file_valid = true;
					} else {
						$scope.brez_file_error = response.data.message;
						$scope.uploaded_brezinys = false;
					}
				}, function (response) {
					console.log(['Error', response]);
				}).then(function () {

				});
			}
		};
		$scope.setDisplayStatus = function (btn) {
			let title = '';
			if (arguments[1]) {
				title = arguments[1];
			}

			for (var i = 0, len = $scope.navigation.length; i < len; i++) {
				if ($scope.navigation[i].id == btn.question_id) {
					$scope.id = i;
					break;
				}
			}

			document.querySelector('.index_container').scrollIntoView({
				behavior: 'smooth'
			});
			if (btn.question_id > 0 && !title) {
				$scope.situation_title.push(btn.title);
			} else if (title) {
				$scope.situation_title.push(title);
			}
			if (btn.question_id == 0) {
				$scope.situation_title = [];
			}
			$scope.displayStatus = btn.question_id;
			$scope.initTooltip();
		};

		$scope.resetForm = function () {
			$scope.stepBack({back_id:0});
			$scope.situation_title = [];
		};

		$scope.stepBack = function (btn) {
			$scope.checking_nr = false;
			$scope.check_data = {};
			$scope.checknr_error_message = '';
			if (btn.back_id >= 0) {
				btn.question_id = btn.back_id;
				for (var i = 0, len = $scope.navigation.length; i < len; i++) {
					if ($scope.navigation[i].id == btn.question_id) {
						$scope.id = i;
						break;
					}
				}
				$scope.displayStatus = btn.question_id;
				if ($scope.situation_title.length > 0) {
					$scope.situation_title.splice($scope.situation_title.length - 1, 1);
				}

				if ($scope.displayStatus === 1) {
					$scope.check_data = {};
				}
			} else {
//			if($scope.situation_title.length>0){
//				$scope.situation_title.splice($scope.situation_title.length-1, 1);
//			}
				$scope.navigation = thirdpersonsData.navigation;
				$scope.setDisplayStatus(0);
			}
			$scope.initTooltip();
		};


		$scope.getIconPath = function (form) {
			if (form.image) {
				return form.image;
			}
			return form.icon2;
		};

		$scope.explicitlyTrustedHtml = function (text) {
			return $sce.trustAsHtml(text);
		};

		$scope.checkRegNr = function (check_registration_nr, btn) {
			$scope.checking_nr = true;
			if ($scope.checkRegNrUrl !== '' && check_registration_nr !== '') {
				$http({
					method: 'POST',
					url: $scope.checkRegNrUrl,
					data: {
						nr: check_registration_nr
					},
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {
					$scope.regNrValid = response.data.success;
					if (response.data.success) {
						$scope.check_data = response.data.data;
						let nr = btn.title + ' ' + check_registration_nr;
						$scope.setDisplayStatus(btn, nr);
					} else {
						$scope.checknr_error_message = response.data.message;
					}
				}, function (response) {
					console.log(['Error', response]);
				}).then(function () {
					$scope.checking_nr = false;
				});
			}
		};

		$scope.termsModal = function () {
			var template = 'thirdpersonsprojects/modal.html';
			var modalInstance = $uibModal.open({
				templateUrl: template,
				controller: 'ThirdpersonsprojectsPreviewCtrl',
				//size: 'sm',
				resolve: {
					item: function () {
						//return true;
					}
				}
			});

//		modalInstance.result.then(function(result){
//
//		}, modalRejectHandler);
		};

		$scope.initTooltip = function () {
			$timeout(function () {
				if ($(".thirdpersonsprojects_form .tooltip, .status-1-holder .tooltip").length) {
					$(".thirdpersonsprojects_form .tooltip, .status-1-holder .tooltip").tooltipster({
						delay: 15,
						multiple: true
					});
				}
			});
		};

		var hideInfoContainers = function () {
			var $info = $('.index_container > .white_bg > .info_container');
			var $error = $('.index_container > .white_bg > .error_container');

			if ($info.length > 0 && $info.is(":visible")) {
				$info.remove();
			}

			if ($error.length > 0 && $error.is(":visible")) {
				$error.remove();
			}
		};

		$scope.onFormSelect = function () {
			$scope.initTooltip();
			hideInfoContainers();
		};


		$scope.checkPreviousNr = function (prev_registration_nr) {
			if ($scope.nrCheckUrl !== '' && prev_registration_nr !== '') {
				$scope.prev_nr_valid = false;
				$http({
					method: 'GET',
					url: $scope.nrCheckUrl,
					params: {number: prev_registration_nr}
				}).then(function (response) {
					if (response.data.success) {
						$scope.prev_nr_valid = true;
					} else {
						$scope.error_message = response.data.message;
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		$scope.checkProjectNr = function () {
			if ($scope.projectNrCheckUrl !== '' && $scope.project_nr !== '' && typeof ($scope.municipality) !== 'undefined') {
				$scope.project_nr_error_message = '';
				$scope.project_nr_valid = false;
				$scope.project_nr_found = false;
				$http({
					method: 'GET',
					url: $scope.projectNrCheckUrl,
					params: {
						project_nr: $scope.project_nr,
						municipality: $scope.municipality
					}
				}).then(function (response) {
					if (response.data.success) {
						$scope.project_nr_valid = true;
					}
					$scope.project_nr_found = response.data.found;
					if (response.data.message) {
						$scope.project_nr_error_message = response.data.message;
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		$scope.formSubmit = function (e) {
			e.preventDefault();
			//submit'as apeina angular validaciją (form[0].submit()), todėl įkėlimo būsena tikrinama ir čia
			if ($scope.files_uploading || $scope.brez_uploading) {
				return;
			}
			$scope.submitted = true;
			let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
			if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
				grecaptcha.ready(function () {
					grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
						if (document.getElementById('g-recaptcha-response-hidden')) {
							$('#g-recaptcha-response-hidden').val(token);
						} else {
							var inp = document.createElement('input');
							inp.type = 'hidden';
							inp.name = 'g-recaptcha-response';
							inp.value = token;
							$scope.form[0].appendChild(inp);
						}
						$scope.form[0].submit();
					});
				});
			} else {
				$scope.form[0].submit();
			}
		};
		
		SessionService.init();

		$scope.$on('$destroy', function() {
		  SessionService.stop();
		});
	}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});

EwSiteApp.controller('ThirdpersonsprojectsPreviewCtrl', ['$scope', '$uibModalInstance', 'item', function ($scope, $uibModalInstance, item) {
		$scope.item = angular.copy(item);
		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			for (var i in $scope.require) {
				$scope.require[i] = false;
			}
			$uibModalInstance.dismiss();
		};
	}]);

//EwSiteApp.directive('datepicker1', function(){
//	return {
//		restrict: 'A',
//		link: function (scope, element, attr) {
//			$(element).pikaday({
//				firstDay: 1,
//				format: 'YYYY-MM-DD',
//				defaultDate: (attr.value)?attr.value: new Date(),
//				setDefaultDate:true,
//				showDaysInNextAndPreviousMonths : true,
//				i18n: {
//					previousMonth : previousMonth,
//					nextMonth     : nextMonth,
//					months        : months,
//					weekdays      : weekdays,
//					weekdaysShort : weekdaysShort
//				}
//			});
//		}
//	};
//});

EwSiteApp.directive('onlyLettersInput', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attr, ngModelCtrl) {
			function fromUser(text) {
				var transformedInput = text.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0430-\u044f ]/g, '');
				if (transformedInput !== text) {
					ngModelCtrl.$setViewValue(transformedInput);
					ngModelCtrl.$render();
				}
				return transformedInput;
			}
			ngModelCtrl.$parsers.push(fromUser);
		}
	};
});

EwSiteApp.directive('coordinates', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModelCtrl) {
			element.on('input', function () {
				let val = element.val();
				if (typeof val !== 'undefined') {
					let cleaned = val.replace(/,/, '.').replace(/[^0-9.]/g, '');
					if (val !== cleaned) {
						element.val(cleaned);
					}
				}
			});
		}
	};
});
